"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClassEndpointKeys = void 0;
var ClassEndpointKeys;
(function (ClassEndpointKeys) {
    ClassEndpointKeys["GetClassesBySubdomain"] = "class.getClassesBySubdomain";
    ClassEndpointKeys["GetMembershipClassAndOffersBySubdomain"] = "class.getMembershipClassAndOffersBySubdomain";
    ClassEndpointKeys["GetClassById"] = "class.getById";
    ClassEndpointKeys["CreateClass"] = "class.create";
    ClassEndpointKeys["UpdateClass"] = "class.update";
    ClassEndpointKeys["UpdateClassModules"] = "class.update.modules";
    ClassEndpointKeys["DeleteClass"] = "class.delete";
    ClassEndpointKeys["GetClasses"] = "class.getClasses";
    ClassEndpointKeys["GetUserCount"] = "users.count";
})(ClassEndpointKeys || (exports.ClassEndpointKeys = ClassEndpointKeys = {}));
